import React from "react";
import { Row, Col, Button } from "reactstrap";
import { Icon } from "@material-ui/core";
import InputFeild from "../../../global/form/input";
import { FieldLabel, TagListInput, ColumnInput, IconButton } from "./common_controls";

const InputsMappingEditor = ({ inputs, onChange, suggestions }) => {
  const list = inputs || [];
  const update = (i, patch) => {
    const next = [...list];
    next[i] = { ...next[i], ...patch };
    onChange(next);
  };
  const remove = i => onChange(list.filter((_, idx) => idx !== i));
  const add = () => onChange([...list, { input_id: "", value: [] }]);

  return (
    <FieldLabel label="Fields to fill on the new record" helper="Which task-form inputs to set, and which report column(s) supply the value.">
      {list.map((input, i) => (
        <Row key={i} className="align-items-center border shadow-sm mx-0 my-1 py-2">
          <Col xs={3}><InputFeild type="number" placeholder="Input ID" value={input.input_id} onChange={e => update(i, { input_id: Number(e.target.value) })} /></Col>
          <Col>
            <TagListInput
              values={Array.isArray(input.value) ? input.value : input.value ? [input.value] : []}
              onChange={value => update(i, { value })}
              placeholder="Report column"
              suggestions={suggestions}
            />
          </Col>
          <Col xs="auto"><IconButton icon="delete" danger onClick={() => remove(i)} /></Col>
        </Row>
      ))}
      <Button size="sm" color="link" className="p-0 mt-1" onClick={add}><Icon fontSize="small" className="align-middle">add</Icon> Add field</Button>
    </FieldLabel>
  );
};

const CodeMappingEditor = ({ mapping, onChange }) => {
  const entries = Object.entries(mapping || {});
  const setEntries = next => onChange(next.reduce((obj, [k, v]) => Object.assign(obj, { [k]: v }), {}));
  const update = (i, k, v) => {
    const next = [...entries];
    next[i] = [k, v];
    setEntries(next);
  };
  return (
    <FieldLabel label="Referral code → Partner ID" helper="Which partner gets credit for each referral/agent code in the report.">
      {entries.map(([k, v], i) => (
        <Row key={i} noGutters className="mb-1">
          <Col xs={5} className="pr-1"><InputFeild placeholder="Code in report" value={k} onChange={e => update(i, e.target.value, v)} /></Col>
          <Col xs={5} className="px-1"><InputFeild placeholder="Partner (User) ID" value={v} onChange={e => update(i, k, e.target.value)} /></Col>
          <Col xs="auto"><IconButton icon="delete" danger onClick={() => setEntries(entries.filter((_, idx) => idx !== i))} /></Col>
        </Row>
      ))}
      <Button size="sm" color="link" className="p-0" onClick={() => setEntries([...entries, ["", ""]])}><Icon fontSize="small" className="align-middle">add</Icon> Add mapping</Button>
    </FieldLabel>
  );
};

export const CaptureMultipleForm = ({ data, onChange, knownColumns }) => {
  const setData = patch => onChange({ ...data, ...patch });
  return (
    <div>
      <div className="small text-muted mb-2">Automatically creates a new task response when a report row's unique ID isn't found yet, but a second identifier (e.g. mobile number) already exists — handles repeat submissions from the same person.</div>
      <Row>
        <Col md={6}>
          <FieldLabel label="Unique ID column" helper="Report column holding the value that should never repeat.">
            <Row noGutters>
              <Col className="pr-1"><ColumnInput value={data.unique && data.unique.col} onChange={col => setData({ unique: { ...data.unique, col } })} suggestions={knownColumns} /></Col>
              <Col xs={4} className="pl-1"><InputFeild type="number" placeholder="Input ID" value={(data.unique && data.unique.input_id) || ""} onChange={e => setData({ unique: { ...data.unique, input_id: Number(e.target.value) } })} /></Col>
            </Row>
          </FieldLabel>
        </Col>
        <Col md={6}>
          <FieldLabel label="Secondary identifier column" helper="Usually the applicant's mobile number.">
            <Row noGutters>
              <Col className="pr-1"><ColumnInput value={data.identifier && data.identifier.col} onChange={col => setData({ identifier: { ...data.identifier, col } })} suggestions={knownColumns} /></Col>
              <Col xs={4} className="pl-1"><InputFeild type="number" placeholder="Input ID (optional)" value={(data.identifier && data.identifier.input_id) || ""} onChange={e => setData({ identifier: { ...data.identifier, input_id: e.target.value ? Number(e.target.value) : undefined } })} /></Col>
            </Row>
          </FieldLabel>
        </Col>
      </Row>
      <InputsMappingEditor inputs={data.inputs} onChange={inputs => setData({ inputs })} suggestions={knownColumns} />
    </div>
  );
};

export const CaptureDataForm = ({ data, onChange, knownColumns }) => {
  const setData = patch => onChange({ ...data, ...patch });
  return (
    <div>
      <div className="small text-muted mb-2">Automatically creates new leads for referral-code-driven onboarding rows not yet in the system.</div>
      <Row>
        <Col md={4}>
          <FieldLabel label="Referral code column"><ColumnInput value={data.codeKey} onChange={codeKey => setData({ codeKey })} suggestions={knownColumns} /></FieldLabel>
        </Col>
        <Col md={4}>
          <FieldLabel label="Default location ID (optional)"><InputFeild type="number" value={data.defaultLocationId || ""} onChange={e => setData({ defaultLocationId: e.target.value ? Number(e.target.value) : undefined })} /></FieldLabel>
        </Col>
      </Row>
      <CodeMappingEditor mapping={data.codeMapping} onChange={codeMapping => setData({ codeMapping })} />
      <InputsMappingEditor inputs={data.inputs} onChange={inputs => setData({ inputs })} suggestions={knownColumns} />
    </div>
  );
};
